export default __webpack_public_path__ + "static/resistanceBands-832e06c0070959213dc85a9df91a7aae.png";